import { WrappedRoleDetailPage } from './lib/RoleDetail';
export * from './lib/components';
export default WrappedRoleDetailPage;
